<template>
  <draggable class="Chat">
    <div class="commandList" v-if="command && currentData">
      <div v-for="(cmd, index) in currentData.memo.split('\n')" :key="index">
        <a class="m-ellipsis" v-text="cmd" @click.prevent="setText(cmd)"></a>
      </div>
    </div>
    <form class="input" @submit.prevent="submit">
      <div class="toList" v-if="inputTo.length > 0">
        <p class="label">秘匿チャット</p>
        <p class="to" @click="removeToList(to)" v-for="to in inputTo" :key="to">@{{(get(to) ? get(to).name : '削除済み')}} <faicon icon="times" /></p>
      </div>
      <div class="item">
        <textarea v-model="inputText" @keypress="input" @mousedown.stop></textarea>
      </div>
      <div class="control">
        <div class="character" @click.prevent="setting = !setting">
          <div class="characterList" v-if="setting">
            <div @click.prevent="setCharacter(null)">
              <figure></figure>
              <p class="name m-ellipsis">選択解除</p>
            </div>
            <div v-if="get(character.key)" v-for="character in characters" :key="character.key"  @click.prevent="setCharacter(character.key)">
              <figure>
                <img :src="src(get(character.key).imageKey)">
              </figure>
              <p class="name m-ellipsis" v-text="get(character.key).name"></p>
            </div>
          </div>
          <figure><img v-if="currentData" :src="src(currentData.imageKey)"></figure>
          <p class="name m-ellipsis" v-text="currentData ? currentData.name : '未設定'"></p>
        </div>
        <div class="command">
          <a class="toggle" @click.prevent="command = !command" v-text="command ? 'チャパレ非表示' : 'チャパレ表示'"></a>
        </div>
        <!-- <button class="" @click.prevent="submit">送信</button> -->
      </div>
    </form>
  </draggable>
</template>

<script>
import calculater from '../../../modules/calculater'
import draggable from '../common/draggable'

export default {
  components: { draggable },
  data() {
    return {
      setting: false,
      command: true
    }
  },
  computed: {
    characters() {
      return this.$store.getters['characterList/$items']
    },
    currentData() {
      return this.get(this.currentKey)
    },
    currentKey() {
      return this.$store.getters['local/currentCharacterKey']
    },
    get() {
      return this.$store.getters['characters/$get']
    },
    getFromList() {
      return this.$store.getters['characterList/$get']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    inputText: {
      get() {
        return this.$store.getters['local/inputText']
      },
      set(value) {
        return this.$store.commit('local/set', { key: 'inputText', value })
      }
    },
    inputTo() {
      return this.$store.getters['local/inputTo']
    }
  },
  methods: {
    submit() {
      const to = this.inputTo
      const text = this.inputText
      const from = this.currentKey || null

      if (text) {
        const params = {};
        const character = this.getFromList(from)
        if (character) {
          Object.keys(character.params).forEach(paramKey => {
            const param = character.params[paramKey]
            params[param.name] = param.value
          })
        }
        const calc = calculater.exec(text, params)
        const extend = {}

        if (calc) {
          extend['calc'] = {
            dice: calc.context,
            result: calc.result
          }
        }

        this.$store.dispatch('messages/$create', { to, from, text, extend })
        this.$store.commit('local/set', { key: 'inputText', value: '' })
      }
    },
    input(e) {
      if (!e.shiftKey && e.key === 'Enter') {
        e.preventDefault()
        this.submit()
      }
    },
    setText(text) {
      if (this.inputText === text) {
        this.submit()
      } else {
        this.$store.commit('local/set', { key: 'inputText', value: text })
      }
    },
    setCharacter(key) {
      this.$store.dispatch('local/currentCharacterKey', key)
      // this.$store.commit('local/set', { key: 'currentCharacterKey', value: key })
    },
    removeToList(key) {
      this.$store.commit('local/removeToList', key)
    }
  }
}
</script>

<style scoped>
.Chat {
  padding: 5px;
  padding-bottom: 0;
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  width: 480px;
  background: #30353E;
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.8);
  color: #111;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 10;
}
.Chat .toggle {
  padding: 5px;
  font-size: 10px;
  background: rgba(0, 0, 0, 0.4);
  color: #ccc;
}
.toList {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.label {
  font-size: 10px;
  color: #fff;
}
.to {
  margin-left: 2px;
  padding: 4px 7px;
  border-radius: 2px;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  font-size: 10px;
}
textarea {
  border: 1px solid #151515;
  border-radius: 2px;
  min-width: 100%;
  height: 30px;
  min-height: 30px;
  max-height: 120px;
  font-size: 14px;
  background: #444;
  resize: none;
}
.control {
  padding: 7px 5px;
  display: flex;
}
.control figure {
  padding: 2px;
  border-radius: 2px;
  background: #fff;
  background: rgba(0, 0, 0, 0.4);
  width: 20px;
  height: 20px;
  overflow: hidden;
}
.control figure img {
  width: 100%;
  height: 100%;
}
.control .name {
  max-width: 60px;
  flex: 1;
}
.character {
  display: flex;
  align-items: center;
  position: relative;
  color: #fff;
  font-size: 10px;
}
.character p {
  margin: 0 5px;
}
.btn {
  margin-left: auto;
}
.command {
  position: relative;
}
.characterList {
  margin-bottom: 7px;
  padding: 5px;
  border-radius: 5px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
  background: #111;
}
.characterList figure {
  overflow: hidden;
  background: #fff;
  width: 16px;
  height: 16px;
}
.characterList::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 50%;
  display: block;
  width: 10px;
  height: 10px;
  background: #111;
  transform: translateX(-50%) rotate(45deg);
}
.characterList > * {
  display: flex;
  align-items: center;
  color: #fff;
}
.characterList > * + * {
  margin-top: 5px;
}
.characterList .name {
  margin-left: 5px;
  font-size: 10px;
  color: #fff;
  flex: 1;
}
.commandList {
  margin-bottom: 5px;
  box-sizing: border-box;
  max-height: 210px;
  position: absolute;
  bottom: 100%;
  right: 0;
  width: 50%;
  background: #30353E;
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
  overflow: auto;
}
.commandList a {
  box-sizing: border-box;
  padding: 7px 10px;
  display: block;
  width: 100%;
  color: #fff;
  font-size: 11px;
  user-select: none;
}
.commandList a:hover {
  background: rgba(0, 0, 0, 0.2);
}
</style>
